import { ref, watch } from 'vue'

const ZOOM_KEY = 'ct-comex-zoom'
const ZOOM_PADRAO = 80
const ZOOM_OPCOES = [60, 70, 80, 90, 100]

export function useZoom () {
  const zoomPercentual = ref(ZOOM_PADRAO)

  const aplicarZoom = (percentual) => {
    const pct = Number(percentual)
    if (isNaN(pct) || pct < 50 || pct > 150) return
    zoomPercentual.value = pct
  }

  const initZoom = () => {
    const salvo = Number(localStorage.getItem(ZOOM_KEY))
    zoomPercentual.value = ZOOM_OPCOES.includes(salvo) ? salvo : ZOOM_PADRAO
  }

  // Sempre que o zoom mudar, aplica o font-size na raiz e persiste
  watch(zoomPercentual, (novo) => {
    document.documentElement.style.fontSize = novo + '%'
    localStorage.setItem(ZOOM_KEY, String(novo))
  })

  return {
    zoomPercentual,
    aplicarZoom,
    initZoom,
    ZOOM_OPCOES
  }
}
